import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function SangleCasse() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20broken%20and%20frayed%20beige%20roller%20shutter%20strap%20hanging%20from%20a%20shutter%20box%20showing%20clear%20damage%20and%20needing%20replacement%20in%20a%20residential%20interior%20clean%20daylight%20professional%20photography%20warm%20neutral%20tones&width=700&height=520&seq=sang-casse&orientation=landscape" alt="Sangle de volet roulant cassée en gros plan" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Sangle de volet roulant cassée ou usée
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              La sangle de volet roulant est la pièce la plus sollicitée de la manoeuvre manuelle. Au fil des années, le textile s&apos;use, s&apos;effiloche et finit par céder sous la traction. L&apos;exposition au soleil, à l&apos;humidité et aux UV accélère le vieillissement des fibres. Une sangle trop vieille peut également patiner sur l&apos;enrouleur sans actionner le tablier, rendant le volet inutilisable.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nos techniciens interviennent sur tous les types de sangles : 14 mm pour les volets légers, 22 mm pour les plus larges ou les tabliers lourds. Nous retirons la sangle usée, nettoyons le dévidoir et vérifions que l&apos;enrouleur rembobine correctement. Nous installons une sangle neuve de qualité, avec la bonne tension et le bon positionnement dans le guidage pour éviter les plis ou les accrocs.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              L&apos;intervention est rapide et ne nécessite pas de démontage complet du coffre. Nous contrôlons systématiquement l&apos;état des pièces associées : enrouleur, guidage, butées de fin de course. Si un autre composant est défectueux, nous vous proposons la réparation complète pour éviter une nouvelle usure prématurée de la sangle neuve.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}